<div class="view-switcher">
  <button class="dw-btn dw-btn_square active"
          (click)="changeType(ViewType.card)"
          [ngClass]="{'active': selectedView === ViewType.card}"
  >
    <img src="assets/images/card-icon.svg" alt="list view">
  </button>
  <button class="dw-btn dw-btn_square first"
          (click)="changeType(ViewType.list)"
          [ngClass]="{'active': selectedView  === ViewType.list}"
  >
    <img src="assets/images/list-icon.svg" alt="card view">
  </button>
</div>
